import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "fixed-expense-list" }
const _hoisted_2 = { class: "flex flex-row-reverse mb-5" }
const _hoisted_3 = { class: "lg:w-1/4 w-full" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "sm:grid grid-cols-6" }
const _hoisted_6 = { class: "col-span-5" }
const _hoisted_7 = { class: "font-bold text-2xl" }
const _hoisted_8 = { class: "sm:flex items-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-grey" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "text-grey sm:ml-1" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = {
  key: 0,
  class: "text-primary font-semibold sm:ml-1"
}
const _hoisted_18 = { class: "left-sct flex flex-col mt-3 sm:mt-0" }
const _hoisted_19 = { class: "flex sm:m-auto gap-4" }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRight = _resolveComponent("InputIconRight")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_ListActions = _resolveComponent("ListActions")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_InputIconRight, {
          class: "input-search-header-custom",
          placeholder: _ctx.placeholder,
          modelValue: _ctx.inputSearch,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputSearch) = $event)),
          canClick: true,
          icon: _ctx.$icon.svg.searchEva,
          onSubmitInput: _ctx.onSearch,
          onKeyup: _withKeys(_ctx.onSearch, ["enter"])
        }, null, 8, ["placeholder", "modelValue", "icon", "onSubmitInput", "onKeyup"])
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.dataSource.length === 0)
        ? (_openBlock(), _createBlock(_component_EmptyState, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource, (data) => {
              return (_openBlock(), _createBlock(_component_Card, {
                class: "card-item mb-4 wrap-card-route",
                key: data.Id
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(data.Name), 1),
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.showedTypes, (item, id) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.Id
                          }, [
                            (id === 0 && data.countHiddenTypes > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createElementVNode("span", _hoisted_10, _toDisplayString(item.Type), 1),
                                  _hoisted_11,
                                  _createElementVNode("span", _hoisted_12, "Rp " + _toDisplayString(item.Nominal) + ",", 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(item.Type), 1),
                                  _hoisted_15,
                                  _createElementVNode("span", _hoisted_16, "Rp " + _toDisplayString(item.Nominal), 1)
                                ]))
                          ]))
                        }), 128)),
                        (data.countHiddenTypes > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(`..${data.countHiddenTypes} Biaya Lainnya`), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_InputSwitch, {
                          class: "input-success",
                          modelValue: data.IsActive,
                          "onUpdate:modelValue": ($event: any) => ((data.IsActive) = $event),
                          onChange: ($event: any) => (_ctx.changeIsActive(data))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                        _createElementVNode("i", {
                          class: "pi pi-ellipsis-h text-base cursor-pointer color-dark",
                          onClick: ($event: any) => (_ctx.showDropDown($event, data))
                        }, null, 8, _hoisted_20)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (_ctx.dataSource.length > 0)
              ? (_openBlock(), _createBlock(_component_Paginator, {
                  key: 0,
                  rows: _ctx.paginate.pageSize,
                  totalRecords: _ctx.paginate.totalRecords,
                  onOnPage: _ctx.onChangePage
                }, null, 8, ["rows", "totalRecords", "onOnPage"]))
              : _createCommentVNode("", true)
          ])),
      _createVNode(_component_OverlayPanel, { ref: "op" }, {
        default: _withCtx(() => [
          _createVNode(_component_ListActions, {
            edit: true,
            del: true,
            editTitle: "Edit Pengeluaran",
            delTitle: "Hapus Pengeluaran",
            onDel: _ctx.onDelete,
            onEdit: _ctx.onEdit
          }, null, 8, ["onDel", "onEdit"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_HjpCofirmModal, {
        show: _ctx.attrModalConfirmation.show,
        imgContent: _ctx.attrModalConfirmation.imgContent,
        title: _ctx.attrModalConfirmation.title,
        subTitle: _ctx.attrModalConfirmation.subTitle,
        btnSubmitTitle: _ctx.attrModalConfirmation.btnSubmitTitle,
        onHideDialog: _ctx.hideDialogConfirmation,
        onOnSubmit: _ctx.onSubmitConfirmation
      }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
    ])
  ]))
}